'use client';

import { ObservedScripts } from 'constants/constants';
import useClientSideErrorReporting from 'hooks/useClientSideErrorReporting';
import thirdPartyScriptErrorObserver from 'utils/miscUtils/thirdPartyScriptErrorObserver';

// App wrapper for executing client-side utilities
export const AppClientWrapper = ({ children }: { children: React.ReactNode }) => {
  // Mount error reporting utilities for client & 3rd party scripts
  useClientSideErrorReporting();
  thirdPartyScriptErrorObserver(ObservedScripts);

  return <>{children}</>;
};
